import type * as mosaicModels from '../../../../models'
import * as models from '../../models'

import type { Plugin } from './plugin'

export class Selectors {
  /**
   * Represents a lookup of {@link models.widget.Preview} by
   * {@link mosaicModels.widget.Ref.Id}
   */
  public readonly widgetPreviewLookup
  /**
   * Returns {@link models.widget.Preview} if exists for a given
   * {@link mosaicModels.widget.Ref.Id}
   */
  public readonly getWidgetPreview
  /**
   * Returns error if exists for a given {@link mosaicModels.widget.Ref.Id}
   */
  public readonly getWidgetError
  /**
   * Returns true if loading is in progress for a given
   * {@link mosaicModels.widget.Ref.Id}
   */
  public readonly getWidgetLoading

  constructor(plugin: Plugin) {
    this.widgetPreviewLookup = plugin.feature.state.project(
      state => state.lookup,
    )
    this.getWidgetPreview = plugin.feature.createSelectorMethod(
      (refId: mosaicModels.widget.Ref.Id) =>
        this.widgetPreviewLookup.project(lookup => lookup[refId]?.preview)
          .asSelector,
    )
    this.getWidgetError = plugin.feature.createSelectorMethod(
      (refId: mosaicModels.widget.Ref.Id) =>
        this.widgetPreviewLookup.project(lookup => lookup[refId]?.error)
          .asSelector,
    )

    this.getWidgetLoading = plugin.feature.createSelectorMethod(
      (refId: mosaicModels.widget.Ref.Id) =>
        this.widgetPreviewLookup.project(lookup => lookup[refId]?.isLoading)
          .asSelector,
    )
  }
}
